import React, { useState } from "react";
import "../css/QuickMenuDialog.css";
import { WEB_LINK } from "utils/strings";
import headerAppIcon from "../../assets/images/header-sabehub-app-icon.svg";
import foundryAppIcon from "../../assets/images/header-app-icon.svg";
import appTextLogo from "../../assets/images/quick-menu-app-text-logo.svg";
import scoreCardIcon from "../../assets/images/dfw-icons/dfw-Club.svg";
import creatorsIcon from "../../assets/images/dfw-icons/dfw-Creators.svg";
import optimistsIcon from "../../assets/images/dfw-icons/dfw-Optimists.svg";
import visionariesIcon from "../../assets/images/dfw-icons/dfw-Visionaries.svg";
import infoIcon from "../../assets/images/dashboard-info-icon.svg";
import BottomSheet from "./BottomSheet";
import { useTabBar } from "services/TabBarProvider";
import {
  CALENDAR_RESERVATION_TYPE,
  MEMBERSHIP_FOUNDER_TYPE,
  MENU_ITEM,
  PROFILE_STATUS,
} from "utils/constants";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";

interface QuickMenuDialogProps {
  userProfileData: any;
  isActiveMember: boolean;
  open: boolean;
  onClose: () => void;
}

const QuickMenuDialog: React.FC<QuickMenuDialogProps> = ({
  userProfileData,
  isActiveMember,
  open,
  onClose,
}) => {
  const navigate = useNavigate();
  const { setSelectedTabBar } = useTabBar();
  const [stepCount, setStepCount] = useState(1);

  const handleReserveSpaceClick = () => {
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.INNOVATE_SPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
    onClose();
  };

  const handleConnectCommunityClick = () => {
    window.open(WEB_LINK.WHATSAPP_CHANNEL, "_blank", "noopener,noreferrer");
    onClose();
  };

  const handleBecomeMemberClick = () => {
    setStepCount(2);
  };

  const handleExperiencesClick = () => {
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.EVENTS,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
    onClose();
  };

  const handleSabehubEcosystemClick = () => {
    if (isActiveMember) {
      sessionStorage.setItem(
        "membershipSelectedTab",
        MEMBERSHIP_FOUNDER_TYPE.SABEHUB,
      );
      setSelectedTabBar(MENU_ITEM.MEMBERSHIP);
    } else {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "Become A Member",
            url: WEB_LINK.BECOME_MEMBER,
          },
        },
      });
    }
    onClose();
  };

  const handleExecutionSpaceClick = () => {
    sessionStorage.setItem(
      "membershipSelectedTab",
      MEMBERSHIP_FOUNDER_TYPE.EXECUTION,
    );
    setSelectedTabBar(MENU_ITEM.MEMBERSHIP);
    onClose();
  };

  return (
    <BottomSheet
      open={open}
      onClose={() => {
        setStepCount(1);
        onClose();
      }}
      height="90dvh"
    >
      <div className="quick-menu-dialog-container">
        <div className="quick-menu-header-container">
          <div className="quick-menu-header-text-container">
            {stepCount === 1 ? (
              <span>
                quick <span style={{ color: "white" }}>menu</span>
              </span>
            ) : (
              <span>
                Become <span style={{ color: "white" }}>a member</span>
              </span>
            )}
          </div>
          <div className="quick-menu-header-container-divider"></div>
          <div className="quick-menu-header-button-container">
            <div
              className="quick-menu-header-container-button"
              onClick={() => {
                setStepCount(1);
                onClose();
              }}
            >
              ✕
            </div>
          </div>
        </div>
        {stepCount !== 1 && (
          <div className="quick-menu-second-step-header-container">
            <span>
              Two Ways In.{" "}
              <span style={{ color: "#C1F700" }}>Pick the Path that fits.</span>
            </span>
          </div>
        )}
        <div className="quick-menu-content-container">
          {stepCount === 1 ? (
            <>
              <div
                className="card-container first-shadow"
                onClick={handleReserveSpaceClick}
              >
                <img src={scoreCardIcon} alt="score-card-icon" />
                <div className="text-container">
                  <span className="title">
                    Reserve A <span style={{ color: "#ff6b35" }}>Space</span>
                  </span>
                  <span className="sub-title">
                    Pick the room that fits your work{" "}
                    <span style={{ color: "#ff6b35" }}>Create, Innovate </span>
                    or
                    <span style={{ color: "#ff6b35" }}> Communicate.</span>
                  </span>
                </div>
              </div>

              <div
                className="card-container second-shadow"
                onClick={handleExperiencesClick}
              >
                <img src={visionariesIcon} alt="score-card-icon" />
                <div className="text-container">
                  <span className="title">
                    Join an{" "}
                    <span style={{ color: "#9B5DE5" }}>Experience </span>
                  </span>
                  <span className="sub-title" style={{ color: "#9B5DE5" }}>
                    Founder Dinners, Brunch Club, Pickleball & Padel Nights
                  </span>
                </div>
              </div>
              <div
                className="card-container third-shadow"
                onClick={handleBecomeMemberClick}
              >
                <img src={optimistsIcon} alt="score-card-icon" />
                <div className="text-container">
                  <span className="title">
                    Become <span style={{ color: "#C1F700" }}>A Member</span>
                  </span>
                  <span className="sub-title">
                    One Membership.{" "}
                    <span style={{ color: "#C1F700" }}>
                      5 Spaces. Endless Growth
                    </span>
                     
                  </span>
                </div>
              </div>
              <div
                className="card-container second-shadow"
                onClick={handleConnectCommunityClick}
              >
                <img src={creatorsIcon} alt="score-card-icon" />
                <div className="text-container">
                  <span className="title">
                    Connect With{" "}
                    <span style={{ color: "#ff6b35" }}>Community</span>
                  </span>
                  <span className="sub-title">
                    Connect with like-minded people and be part of a supportive
                    community.
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className="card-container first-shadow"
                onClick={handleSabehubEcosystemClick}
              >
                <div>
                  <div className="sub-container">
                    <img src={foundryAppIcon} alt="score-card-icon" />
                    <div className="text-container">
                      <span className="title">SabeHub ECOSYSTEM</span>
                      <span className="sub-title">
                        Access the Full Ecosystem - Execution Space, Wellness
                        (Recovery Built-in), Clean- Fuel Café, Experiences &
                        Retreat.
                      </span>
                    </div>
                  </div>
                  {userProfileData?.credit?.status ===
                    PROFILE_STATUS.PAYMENT_PENDING && (
                    <div className="info-container" style={{ width: "288px" }}>
                      <img src={infoIcon} alt="info-icon" />
                      <span>
                        Membership Approved,{" "}
                        <span style={{ color: "#ff6b35" }}>
                          Complete your payment
                        </span>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div
                className="card-container second-shadow"
                onClick={handleExecutionSpaceClick}
              >
                <img src={headerAppIcon} alt="score-card-icon" />
                <div className="text-container">
                  <span className="title">Execution Space Membership</span>
                  <span className="sub-title">
                    Access to Create , Innovate & Communicate . Workspace More
                    than a Seat & Wifi.
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="quick-menu-footer-container">
          <span>Powered By</span>
          <div className="sub-conatiner">
            <img
              src={headerAppIcon}
              alt="quick-menu-app-logo"
              className="footer-app-icon"
            />
            <img src={appTextLogo} alt="quick-menu-app-text-logo" />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default QuickMenuDialog;
